(() => {
  'use strict';

  const identifier = value => typeof value === 'string' && value.trim().length > 0 && value.length <= 128;
  const positive = value => Number.isSafeInteger(value) && value > 0;
  const protectedProducts = [10443029971249, 10444269945137];
  function configuration(value) {
    if (!value || value.version !== 1 || typeof value.enabled !== 'boolean' ||
      !identifier(value.offerId) || value.offerId === 'grounding-pdp-v1' ||
      !positive(value.productId) || protectedProducts.includes(value.productId) ||
      !Array.isArray(value.eligibleProductIds) || !value.eligibleProductIds.length ||
      !value.eligibleProductIds.every(id => positive(id) && !protectedProducts.includes(id)) ||
      !value.eligibleProductIds.includes(value.productId) ||
      new Set(value.eligibleProductIds).size !== value.eligibleProductIds.length ||
      !value.gifts || typeof value.gifts !== 'object' || Array.isArray(value.gifts) ||
      !Object.keys(value.gifts).length || !Object.entries(value.gifts).every(([key, id]) => identifier(key) && positive(id)) ||
      new Set(Object.values(value.gifts)).size !== Object.keys(value.gifts).length ||
      !Array.isArray(value.tiers) || value.tiers.length !== 3 ||
      !value.tiers.every((tier, index) => tier?.minimumQuantity === [1, 2, 4][index] &&
        Number.isSafeInteger(tier.percentage) && tier.percentage >= 0 && tier.percentage <= 100 &&
        Array.isArray(tier.gifts) && new Set(tier.gifts).size === tier.gifts.length &&
        tier.gifts.every(key => Object.hasOwn(value.gifts, key)))) return false;
    return true;
  }

  const offers = new Map();
  try {
    const value = JSON.parse(document.querySelector('[data-product-atf-offers]')?.textContent || 'null');
    if (value?.version === 1 && Array.isArray(value.offers) && value.offers.every(configuration) &&
      new Set(value.offers.map(offer => offer.offerId)).size === value.offers.length &&
      new Set(value.offers.flatMap(offer => offer.eligibleProductIds)).size === value.offers.reduce((sum, offer) => sum + offer.eligibleProductIds.length, 0)) {
      value.offers.forEach(offer => offers.set(offer.offerId, offer));
    }
  } catch {}

  const signature = offer => JSON.stringify([offer.version, offer.enabled, offer.offerId, offer.productId,
    offer.eligibleProductIds, Object.entries(offer.gifts).sort(([a], [b]) => a.localeCompare(b)),
    offer.tiers.map(tier => [tier.minimumQuantity, tier.percentage, [...tier.gifts].sort()])]);

  function matches(offer) {
    const registered = offers.get(offer?.offerId);
    return !!registered?.enabled && configuration(offer) && signature(registered) === signature(offer);
  }

  function giftUpdates(cart) {
    const engine = window.GroundingOffer;
    const updates = window.CloudNineQuantityOffers?.giftUpdates(cart) || {};
    if (typeof engine?.giftUpdates !== 'function') return updates;
    for (const offer of offers.values()) {
      if (offer.enabled) Object.assign(updates, engine.giftUpdates(offer, cart));
    }
    return updates;
  }

  window.CloudNineProductOffers = {matches, giftUpdates};
})();
